import React, {FC, ReactElement} from 'react';

import {ContactMergeInformationBannerContainer} from '../../../../../../../../src/components/contacts/common/contactMergeInformationBannerContainer';
import {SidePanelHeader} from '../../../../../../../../src/components/inboxes/side/sidePanelHeader';
import {Trans} from '../../../../../../../shared/helpers/src/internationalization/react';
import {Handler} from '../../../../../../../shared/helpers/src/react/reactHelpers';
import {AsyncStatusesEnum} from '../../../../../../../shared/helpers/src/types/asyncStatuses';
import {IconButton} from '../../../../../../../shared/ui/src/components/buttons/iconButton';
import {UserThemeConsumer} from '../../../../../../../shared/ui/src/theme/userThemeConsumer';

/*
 * Props.
 */

interface MergeContactsSidePanelHeaderProps {
  isInfoBoxVisible: boolean;
  status?: AsyncStatusesEnum;
  onToggleInfoBox: Handler;
}

/*
 * Component.
 */

export const MergeContactsSidePanelHeader: FC<MergeContactsSidePanelHeaderProps> = (props) => {
  const {isInfoBoxVisible, status, onToggleInfoBox} = props;
  const isLoading = status === AsyncStatusesEnum.LOADING;

  return (
    <SidePanelHeader
      title={<Trans id="contacts-manager-merge-contacts-title">Review your merged contact</Trans>}
      additionalActionsAfter={maybeRenderAdditionalAfterActions(isInfoBoxVisible, status, onToggleInfoBox)}
      shouldHideCloseButton
    >
      {!isLoading && <ContactMergeInformationBannerContainer />}
    </SidePanelHeader>
  );
};

/*
 * Helpers.
 */

function maybeRenderAdditionalAfterActions(
  isInfoBoxVisible: boolean,
  status: AsyncStatusesEnum | undefined,
  onToggleInfoBox: Handler,
): ReactElement | undefined {
  if (status !== AsyncStatusesEnum.LOADED) {
    return undefined;
  }
  return (
    <UserThemeConsumer>
      {(theme) => (
        <IconButton
          iconName={isInfoBoxVisible ? 'infoFilled' : 'info'}
          color={isInfoBoxVisible ? theme.palette.blue.shade40 : undefined}
          hoverColor={isInfoBoxVisible ? theme.palette.blue.shade40 : undefined}
          label={<Trans id="contacts-manager-merge-sidepanel-toggle-button">Toggle</Trans>}
          onClick={onToggleInfoBox}
        />
      )}
    </UserThemeConsumer>
  );
}
